import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCookie } from '../../utils/cookieUtil';
import { API_HOST } from "../../constants";

const SessionContext = createContext();
SessionContext.displayName = "SessionContext";

export const SessionProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [user, setUser] = useState(null);    
    const [isLoading, setIsLoading] = useState(true); // 로딩 상태 추가

    useEffect(() => {  
        const checkSession = async () => {
            setIsLoading(true); // 세션 체크 시작 시 로딩 상태 활성화
            try {
                const csrfToken = getCookie('csrftoken');
                const response = await fetch(API_HOST + '/api/check-session/', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRFToken': csrfToken,
                    },
                    credentials: 'include',
                });
    
                if (response.status === 401) {  // 세션 만료 시 로그아웃 처리
                    setIsLoggedIn(false);
                    setUser(null);
                    return;
                }
    
                const result = await response.json();            
                if (result.loggedIn) {
                    setIsLoggedIn(true);
                    fetchUserInfo();
                } else {
                    setIsLoggedIn(false);
                    setUser(null);
                }
            } catch (error) {
                console.error('Failed to check session', error);
                setIsLoggedIn(false);
                setUser(null);
            } finally {
                setIsLoading(false); // 세션 체크 완료 후 로딩 상태 비활성화
            }
        };
        
        checkSession();
    }, [isLoggedIn]);

    const fetchUserInfo = async () => {
        try {
            const csrfToken = getCookie('csrftoken');
            const response = await fetch(API_HOST + '/api/user-info/', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                credentials: 'include',
            });

            const userInfo = await response.json();
            setUser(userInfo);

        } catch (error) {
            console.error('Failed to fetch user info', error);
        }
    };    

    return (
        <SessionContext.Provider value={{ isLoggedIn, setIsLoggedIn, user, fetchUserInfo, isLoading }}>
            {children}
        </SessionContext.Provider>
    );
};

export const useSession = () => useContext(SessionContext);